(function(){
  // Convert Shopify rich_text JSON strings to HTML
  function parseRichText(text) {
    if (!text || !text.includes('"type"=>')) return null;
    try {
      // Shopify outputs Ruby hash syntax: {"type"=>"root"...}
      // Convert to valid JSON: replace => with : and "key"=> with "key":
      var json = text
        .replace(/=>/g, ':')
        .replace(/nil/g, 'null');
      var data = JSON.parse(json);
      return renderNode(data);
    } catch(e) { return null; }
  }

  function renderNode(node) {
    if (!node) return '';
    if (node.type === 'text') {
      var t = node.value || '';
      if (node.bold) t = '<strong>' + t + '</strong>';
      if (node.italic) t = '<em>' + t + '</em>';
      return t;
    }
    var children = (node.children || []).map(renderNode).join('');
    switch(node.type) {
      case 'root': return children;
      case 'paragraph': return children ? '<p>' + children + '</p>' : '';
      case 'heading': return '<h' + (node.level||2) + '>' + children + '</h' + (node.level||2) + '>';
      case 'list': return node.listType === 'ordered' ? '<ol>' + children + '</ol>' : '<ul>' + children + '</ul>';
      case 'list-item': return '<li>' + children + '</li>';
      case 'link': return '<a href="' + (node.url||'#') + '">' + children + '</a>';
      case 'strong': return '<strong>' + children + '</strong>';
      case 'emphasis': return '<em>' + children + '</em>';
      default: return children;
    }
  }

  function convertRichTextFields() {
    // Fix accordion bodies with raw JSON
    document.querySelectorAll('.ddi-hero__acc__body').forEach(function(el) {
      var raw = el.textContent.trim();
      if (raw.includes('"type"=>')) {
        var html = parseRichText(raw);
        if (html) el.innerHTML = html;
      }
    });

    // Convert dash-prefixed bullet lines in metafield wraps
    document.querySelectorAll('.ddi-hero__bullets-wrap--mf p').forEach(function(p) {
      var html = p.innerHTML;
      if (html.indexOf('- ') === -1) return;
      var lines = html.split(/<br\s*\/?>/i);
      if (lines.length <= 1) lines = html.split('\n');
      var hasDash = lines.some(function(l){ return l.trim().indexOf('- ') === 0 || l.trim() === '-'; });
      if (!hasDash) return;
      var ul = document.createElement('ul');
      lines.forEach(function(line) {
        var stripped = line.trim().replace(/^-\s*/, '');
        if (!stripped) return;
        var li = document.createElement('li');
        li.innerHTML = stripped;
        ul.appendChild(li);
      });
      if (ul.children.length > 0) p.replaceWith(ul);
    });
  }

  // Run immediately, on DOMContentLoaded, and with a delay fallback
  // (details elements render content immediately but may be parsed after script fires)
  function runWhenReady() {
    convertRichTextFields();
    // Fallback: re-run after short delay in case DOM wasn't fully parsed
    setTimeout(convertRichTextFields, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenReady);
  } else {
    runWhenReady();
  }
  document.addEventListener('shopify:section:load', convertRichTextFields);
  // Also run when any details element is opened
  document.addEventListener('toggle', function(e) {
    if (e.target && e.target.closest && e.target.closest('.ddi-hero__acc')) {
      convertRichTextFields();
    }
  }, true);
})();

    (function(){
      if(window.__ddiZoomInit) return; window.__ddiZoomInit = true;
      var PSWP='https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/';
      var lightbox=null, dataSrc=[], thumbsHTML='', dataReady=false, busy=false;
      function hires(im){ var s=im.getAttribute('srcset')||'', best=im.getAttribute('src')||'', w=0; s.split(',').forEach(function(p){ var m=p.trim().match(/(\S+)\s+(\d+)w/); if(m&&(+m[2])>w){w=+m[2];best=m[1];} }); return best; }
      function widthURL(u,px){ return u.replace(/([?&]width=)\d+/i,'$1'+px); }
      function collect(done){
        if(dataReady){ done(true); return; }
        var strip=document.querySelector('[id^="ddi-thumb-strip-"]');
        var imgs=strip?[].slice.call(strip.querySelectorAll('[data-ddi-thumb] img')):[];
        if(!imgs.length){ done(false); return; }
        var th=[], n=imgs.length, pending=n; dataSrc=new Array(n);
        imgs.forEach(function(im,i){
          var full=widthURL(hires(im),1600), thumb=im.getAttribute('src')||full;
          /* PERF F-20260911-07: was widthURL(thumb,96). Since F-20260911-02 every thumb in
             the strip ships a plain src at width=144 with no srcset, so 144 is already in the
             HTTP cache by the time the lightbox opens. Asking for 96 downloaded a second copy
             of every gallery image for nothing; 144 is a cache hit and costs zero extra bytes.
             The lightbox thumb is rendered at 38-44 CSS px, so 144 is still oversupplied. */
          th[i]='<button class="ddi-pswp-thumb" type="button" data-i="'+i+'"><img src="'+widthURL(thumb,144)+'" alt="" loading="lazy"></button>';
          var probe=new Image();
          probe.onload=probe.onerror=function(){
            var w=probe.naturalWidth||1, h=probe.naturalHeight||1, s=1600/Math.max(w,h);
            dataSrc[i]={src:full, width:Math.round(w*s)||1600, height:Math.round(h*s)||1600, alt:im.alt||''};
            if(--pending===0){ thumbsHTML=th.join(''); dataReady=true; done(true); }
          };
          /* PERF F-20260911-07: was widthURL(thumb,64). This probe exists only to read
             naturalWidth/naturalHeight for the aspect ratio - any width gives the same ratio -
             so it was firing one extra width=64 request per gallery image purely to measure.
             144 matches the thumb src the section now emits, so the probe resolves from cache. */
          probe.src=widthURL(thumb,144);
        });
      }
      function activeIndex(){ var t=document.querySelector('[data-ddi-thumb].is-active'); return t?(parseInt(t.getAttribute('data-ddi-thumb'),10)||0):0; }
      function ensureCSS(){ if(document.getElementById('ddi-pswp-css'))return; var l=document.createElement('link'); l.id='ddi-pswp-css'; l.rel='stylesheet'; l.href=PSWP+'photoswipe.css'; document.head.appendChild(l); }
      function loadJS(u){ return new Promise(function(ok,no){ var s=document.createElement('script'); s.src=u; s.async=true; s.onload=ok; s.onerror=no; document.head.appendChild(s); }); }
      function loadPSWP(){
        if(window.PhotoSwipe && window.PhotoSwipeLightbox) return Promise.resolve();
        return Promise.all([loadJS(PSWP+'umd/photoswipe.umd.min.js'), loadJS(PSWP+'umd/photoswipe-lightbox.umd.min.js')]).then(function(){
          if(!window.PhotoSwipe || !window.PhotoSwipeLightbox) throw new Error('pswp');
        });
      }
      function ensure(cb){
        if(lightbox){ cb(); return; }
        ensureCSS();
        /* F-20261015-19: was a dynamic import of the esm builds. Shopify's CDN minifier rewrites a dynamic import
           into require(), which does not exist in a browser, so every desktop photo click failed
           silently. The UMD builds load as plain scripts and set window.PhotoSwipe(Lightbox). */
        loadPSWP().then(function(){
          var PhotoSwipeLightbox=window.PhotoSwipeLightbox;
          lightbox=new PhotoSwipeLightbox({ dataSource:dataSrc, pswpModule:window.PhotoSwipe, bgOpacity:0.96, padding:{top:16,bottom:92,left:10,right:10}, wheelToZoom:true });
          lightbox.on('uiRegister', function(){
            lightbox.pswp.ui.registerElement({ name:'ddi-bar', order:9, isButton:false, appendTo:'wrapper',
              html:'<div class="ddi-pswp-bar"><p class="ddi-pswp-count"></p><div class="ddi-pswp-thumbs">'+thumbsHTML+'</div></div>',
              onInit:function(el,pswp){
                var count=el.querySelector('.ddi-pswp-count'), rail=el.querySelector('.ddi-pswp-thumbs'), thumbs=[].slice.call(el.querySelectorAll('.ddi-pswp-thumb'));
                function sync(){
                  if(!rail || !document.body.contains(rail)) return;
                  var i=pswp.currIndex;
                  count.textContent=(i+1)+' / '+pswp.getNumItems();
                  thumbs.forEach(function(b){ b.classList.toggle('is-active', (+b.getAttribute('data-i'))===i); });
                  var overflow = rail.scrollWidth > rail.clientWidth + 1;
                  rail.style.justifyContent = overflow ? 'flex-start' : 'center';
                  if(overflow){ var a=thumbs[i]; if(a){ var tr=a.getBoundingClientRect(), rr=rail.getBoundingClientRect(); rail.scrollLeft += (tr.left + tr.width/2) - (rr.left + rr.width/2); } }
                  var sw=document.querySelector('.pswp__scroll-wrap'); if(sw && sw.scrollLeft) sw.scrollLeft=0;
                }
                el.addEventListener('click', function(e){ var b=e.target.closest('.ddi-pswp-thumb'); if(b) pswp.goTo(+b.getAttribute('data-i')); });
                pswp.on('change', sync);
                if(pswp.on) pswp.on('resize', sync);
                sync();
              }
            });
          });
          lightbox.init(); cb();
        }).catch(function(){ busy=false; });
      }
      document.addEventListener('click', function(e){
        var img=e.target.closest('[id^="ddi-main-img-"]'); var railSlide=e.target.closest('[data-ddi-rail-img]'); if(!img && !railSlide) return;
        e.preventDefault(); if(busy) return; busy=true;
        var idx=railSlide?parseInt(railSlide.getAttribute('data-ddi-rail-img'),10):activeIndex();
        collect(function(ok){ if(!ok){ busy=false; return; } ensure(function(){ lightbox.loadAndOpen(idx, dataSrc); busy=false; }); });
      });
      var pre=function(){ collect(function(){}); };
      if(document.readyState==='complete'){ setTimeout(pre,1500); } else { window.addEventListener('load', function(){ setTimeout(pre,1500); }); }
    })();
    
